import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c(VOverlay,{attrs:{"value":_vm.show}},[_c(VProgressCircular,{attrs:{"size":100,"color":"white","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }